if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickViewWrapper = this.querySelector('.quick-view-product-info');
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.querySelector('.quick-add-modal__content').classList.add('removing-modal');
        setTimeout(() => {
          this.modalContent.innerHTML = '';
          this.quickViewWrapper.querySelector('.quick-view-media').innerHTML = '';
          this.quickViewWrapper.querySelector('.quick-view-meta').innerHTML = '';

          if (preventFocus) this.openedBy = null;
          super.hide();
          this.querySelector('.quick-add-modal__content').classList.remove('removing-modal');
          document.querySelectorAll(`video[autoplay="autoplay"]`).forEach((video) => {
            video.play();
          });
        }, 500);

       

      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            let productElement = responseHTML.querySelector('product-info');
            productElement.querySelector('.breadcum')?.remove();
            productElement.querySelector('.block-zenrush')?.remove();
            productElement.querySelector('.block-story-feed')?.remove();
            const productTitle = productElement.querySelector('.product__title');
            const productReview = productElement.querySelector('.product__title + .shopify-app-block');
            const productPrice = productElement.querySelector('.main-price');
            const featuredImage = productElement.querySelector('.product__media-wrapper .media-wrapper img');
            this.querySelector('.quick-view-meta').appendChild(productTitle);
            this.querySelector('.quick-view-meta').appendChild(productReview);
            this.querySelector('.quick-view-meta').appendChild(productPrice);
            this.querySelector('.quick-view-media').appendChild(featuredImage);

            // if (typeof Swiper !== "undefined" && Swiper) {
            //   new Swiper(productElement.querySelector('.mySwiper'), { slidesPerView: 3 });
            //   new Swiper(productElement.querySelector('.mySwiper2'), { slidesPerView: 3 });
            // }
            this.addEventListener('change', () => {
              const currentImage = this.querySelector('.swiper-slide-active img');
              if (currentImage) {
                this.querySelector('.quick-view-media img').src = '';
                this.querySelector('.quick-view-media img').src = currentImage.src;
                this.querySelector('.quick-view-media img').setAttribute('srcset', currentImage.srcset);
              }
            });

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);


          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!customElements.get('small-quick-view')) {
  class smallQuickView extends HTMLElement {
    constructor() {
      super();
      this.parentEl = this.closest('.card');
      this.button = this.parentEl.querySelector('button[type="button"]');
      this.addEventListener('change', this.onChange.bind(this));
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    onChange(event) {
      const input = event.target;
      let variantId = input.dataset.variantId;
      let stock = input.dataset.stock;
      if (input.checked) {
        this.updateVariant(variantId);
      }
      this.changeTypo(stock);
    }

    changeTypo(stock) {
      if (stock == 'true') {
        this.button.disabled = false;
        this.button.classList.remove('disabled');
        this.button.querySelector('span.atc-text').textContent = this.button.dataset.updateAtc;
      } else {
        this.button.disabled = true;
        this.button.classList.add('disabled');
        this.button.querySelector('span.atc-text').textContent = this.button.dataset.soldOutText;
      }
    }

    updateVariant(variantId) {
      this.parentEl.querySelector('[name="id"]').value = variantId;
    }

    updateDom() {
      this.parentEl.querySelector('.card__information-wrapper')?.classList.add('hidden');
      this.parentEl.querySelector('.card-information')?.classList.add('hidden');
      this.parentEl.querySelector('.card__inner')?.classList.add('hidden');
      this.parentEl.querySelector('.cart_quick_view .card__heading')?.classList.add('hidden');
      this.classList.remove('hidden');
      this.parentEl.querySelector('.subscription-product')?.classList.remove('hidden');
      this.button.querySelector('span.atc-text').textContent = this.button.dataset.atcText;
    }

    close() {
      this.parentEl.querySelector('.card__information-wrapper')?.classList.remove('hidden');
      this.parentEl.querySelector('.card-information')?.classList.remove('hidden');
      this.parentEl.querySelector('.card__inner')?.classList.remove('hidden');
      this.parentEl.querySelector('.subscription-product')?.classList.add('hidden');
      this.classList.add('hidden');
      this.button.querySelector('span.atc-text').textContent = this.button.dataset.atcText;
      this.button.type = this.button.dataset.type;
      this.button.disabled = false;
      this.button.classList.remove('disabled');
      if (this.querySelector('input')) {
        this.querySelector('input').checked = true;
      }
      if (this.parentEl.querySelector('input[value="one-time"]')) {
        this.parentEl.querySelector('input[value="one-time"]').checked = true;
        this.parentEl.querySelector('.product-selling-plan-id').disabled = true;
      }
      if(this.button.dataset?.soldOut=='true'){
        this.button.disabled = true;
        this.button.classList.add('disabled');
        this.button.querySelector('span.atc-text').textContent = this.button.dataset.soldOutText;
      }

    }

    onClick(event) {
      if (this.button.type == 'submit') return;
      event.preventDefault();
      this.updateDom();
      this.button.type = 'submit';
      const stock = this.querySelector('input[checked]')?.dataset?.stock;
      stock && this.changeTypo(stock);
      this.parentEl.querySelector('subscription-widget')?.tooltip();

    }
  }

  customElements.define('small-quick-view', smallQuickView);
}
